import ResourceCard from "./resource-card"
import FastlyAssetPath from "../fastly-asset"

const ResourceFile = (content) => {
  const resource = content.content

  const data = {
    title: `${resource.name}`,
    description: resource.description ? resource.description.childMarkdownRemark.html : null,
    type: resource.type ? resource.type.toLowerCase() : null,
    url: resource.file ? FastlyAssetPath(resource.file.file.url) : null,
    urlType: "application/pdf;",
    featured: resource.featured ? resource.featured : null,
  }

  return <ResourceCard content={data} />
}

export default ResourceFile
